var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-success"},[_c('h1',[_vm._v("お支払いありがとうございます！お手続きが完了しました。")]),_c('button',{staticClass:"home-btn btn-comp",on:{"click":function($event){return _vm.goHome()}}},[_vm._v("ログイン")])])
}
var staticRenderFns = []

export { render, staticRenderFns }